import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Checkbox } from "antd";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { Size } from "@type/sizing";

const sizeMap = {
    medium: {
        dimension: "fontSizeLG",
        height: "9.14",
        width: "5.71",
    },
    large: {
        dimension: "fontSizeXL",
        height: "11.43",
        width: "7.14",
    },
};

const getCheckboxTickCSS = (size: string) => {
    return css`
        height: ${sizeMap[size].height}px;
        width: ${sizeMap[size].width}px;
        transform: rotate(45deg) scale(1) translate(-100%, -20%);
        left: 50%;
        top: ${size === Size.large && "48%"};
    `;
};

const getCheckboxIndeterminateCSS = (dimension) => {
    return css`
        width: ${dimension / 2}px;
        height: 2px;
        border-radius: 1px;
        background-color: #fff;
    `;
};

const getCheckboxCSS = (
    size: string,
    indeterminate: boolean,
    checked: boolean,
    disabled: boolean
) => {
    const token = useEnigmaToken();
    const dimension = token[sizeMap[size].dimension];
    return css`
        .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
            outline-offset: 0px;
            border-color: ${token.colorPrimary};
            background-color: ${!indeterminate &&
            !checked &&
            token.color?.Selection?.selectionBgFill};
            outline-color: ${token.color?.bg?.fill?.fillPrimarySubtle};
        }

        .ant-checkbox-inner {
            width: ${dimension}px;
            height: ${dimension}px;
            border-color: ${!disabled && indeterminate && token.colorPrimary};
            z-index: 1;
            position: relative;
            background-color: ${!disabled &&
            indeterminate &&
            token.colorPrimary};
            border-radius: ${token.borderRadiusSM}px;

            :hover {
                background-color: ${!(disabled || checked || indeterminate) &&
                token.color?.Selection?.selectionBgFill};
            }

            &::after {
                ${indeterminate && getCheckboxIndeterminateCSS(dimension)}
                ${checked && getCheckboxTickCSS(size)};
            }
        }
    `;
};

export const StyledCheckBox = styled(Checkbox)<{
    size?: string;
    indeterminate?: boolean;
    checked?: boolean;
}>`
    ${({
        size = "medium",
        indeterminate = false,
        checked = false,
        disabled = false,
    }) => getCheckboxCSS(size, indeterminate, checked, disabled)}
`;
